import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/axiosConfig';
import { useAuth } from '../context/AuthContext';
import { hasNavPermission } from '../components/ProtectedRoute';
import './AdminHubPage.css';
import '../styles/priceAlert.css';

const SECTIONS = [
  { to: '/ventas/formulario', icon: '📝', label: 'Formulario de Ventas', desc: 'Registrar una nueva hoja de cosecha' },
  { to: '/ventas/historial', icon: '📋', label: 'Historial de Ventas', desc: 'Ver las hojas de cosecha registradas' },
  // `key`: an extra grant the card needs besides 'ventas'.
  { to: '/ventas/resumen', icon: '📊', label: 'Resumen de Ventas', desc: 'Totales de cajas y montos semana por semana', key: 'sales_summary' },
];

export default function VentasPage() {
  const { user } = useAuth();
  const canSeePrices = hasNavPermission(user, 'sale_prices');
  const [missingPrices, setMissingPrices] = useState(0);

  useEffect(() => {
    if (!canSeePrices) return;
    api.get('sales/missing-prices/').then((r) => setMissingPrices(r.data.count)).catch(() => {});
  }, [canSeePrices]);

  return (
    <div className="admin-hub-root">
      <h1 className="admin-hub-title hub-title-divided">💰 Ventas</h1>
      {missingPrices > 0 && (
        <div className="price-alert" role="alert">
          <span>
            ⚠️ {missingPrices} {missingPrices === 1 ? 'venta no tiene' : 'ventas no tienen'} Precio 43 lbs (vacío o 0,00).
          </span>
          <Link to="/ventas/historial?sinPrecio=1" className="price-alert-btn">Revisar</Link>
        </div>
      )}
      <div className="admin-hub-grid">
        {SECTIONS.filter((s) => !s.key || hasNavPermission(user, s.key)).map((s) => (
          <Link key={s.to} to={s.to} className="admin-hub-card">
            <span className="admin-hub-icon">{s.icon}</span>
            <div>
              <div className="admin-hub-label">{s.label}</div>
              <div className="admin-hub-desc">{s.desc}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
